import React from 'react';
import { Card, CardProps, FlexProps } from 'antd';

interface PageLayoutProps extends CardProps {
  children: React.ReactNode;
  isScrollable?: boolean;
  padding?: string;
  style?: React.CSSProperties;
}

/**
 * A layout component optimized for detail pages with scrollable content.
 * Provides consistent spacing and scroll behavior for pages like AccountDetail, CharacterDetail, etc.
 * 
 * @param gap - Space between child elements. Defaults to 16
 * @param padding - Padding around the content. Defaults to '20px'
 */
const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  isScrollable = true,
  padding = '16px',
  style,
  ...restProps
}) => {
  return (
    <Card
      {...restProps}
      style={{
        height: '100%',
        overflow: isScrollable ? 'auto' : 'hidden',
        display: 'flex',
        flexDirection: 'column',
        ...style,
      }}
      styles={{
        body: {
          padding,
        },
      }}
    >
      {children}
    </Card>
  );
};

export default PageLayout;

